import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuController, NavController, PopoverController,  Animation, AnimationController  } from '@ionic/angular';
import { CartService, Category, CategoryService } from 'octali-lib-shop';
import { DisplayerService, LoggerService } from 'octali-lib-utils';
import { Location } from '@angular/common';
import { Profile, UserService } from 'octali-lib-firebase-utils';
import { combineLatest } from 'rxjs';
import { LoginPage } from 'src/app/pages/user/login/login.page';
import { AccountPopoverComponent } from '../../user/account-popover/account-popover.component';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() title:string;
  @Input() urlReturn:string;
  @Input() displayButtons:boolean;
  @Input() displayBack:boolean;

  private descending: boolean = true;
  public order: number = 1;
  public column: string = 'name';
  public profile: Profile;

  public cartItemCount:Number= 0;
  public categories: Array<Category> = [];
  public categoryId:string;
  public categoriesId:Map<string,Category>;

  public newsSelected:boolean = false;
  public discountSelected:boolean = false;
  
  constructor(
    private activatedRoute: ActivatedRoute,
    private router : Router,
    private categoryService:CategoryService,
    private popoverController: PopoverController,
    private _location: Location,
    private displayer:DisplayerService,
    private logger: LoggerService,
    private menu: MenuController,
    private navCtrl: NavController,
    private cartService: CartService,
    private animationCtrl: AnimationController,
    private profileService: UserService,
    private titleService: Title, 
    private meta: Meta,
  ) {
    this.title = "Dégriff'laine"
    let title = "Dégrifflaine - mercerie et fils à tricoter, crocheter, broder, coudre";
    this.titleService.setTitle(title);
    this.meta.updateTag({ property: 'og:site_name', content: title });
    this.meta.updateTag({ property: 'og:url', content:'https://degrifflaine.fr'+this.router.url});
    this.meta.updateTag({ property: 'og:title', content:title });
    //this.meta.updateTag({ property: 'og:image', content: this.product.image.data});
    
    this.displayButtons = true;
    combineLatest( [
      this.profileService.getUser(),
      this.cartService.getCartObs(),
      this.categoryService.getCategoriesIdObs()
    ])
    .subscribe( ([user, cart, categoriesId]) => {
      if( user && cart && categoriesId ){
        this.profile = user;
        this.categoriesId = categoriesId;
        if( this.cartItemCount != cart.nbItems){
          this.cartItemCount = cart.nbItems;
        }
      }
    });
   }

   async ngOnInit() {
    this.categoryId = await this.activatedRoute.snapshot.paramMap.get('id');
    this.categoryService.getCategoriesObs().subscribe( categories => {
      if( categories != null && categories.length>0) {
        this.categories = categories.filter( cat => (cat.level === 0) );
      }
    });    
  }

  isSelected(id){
    if( id == "accueil")
      return this.router.url == "/accueil";
    if(id == "" || id == null || this.categoryId =="" || this.categoryId == null){
      return false
    }
    if( this.categoryId == id){
      return true;
    } else 
      if(this.categoriesId && this.categoriesId.get(this.categoryId)?.parent == id) {
        return true;
      }else {
    
    
    
          return false;
      }
  }

  openMenu() {
    this.menu.enable(true,"home");
    this.menu.open("home");
    
  }

  seeCart(){
    //this.router.navigate(['/user/cart/detail']);
    this.navCtrl.navigateRoot( 'panier' );
  }

  goTo(page){
    //this.router.navigate(['/product/'+page]);
    this.navCtrl.navigateRoot( "produit/"+page );
  }

  seeHome() {
    this.navCtrl.navigateRoot( "accueil" );
  }

linkCat( category ):string{
  return "categories/"+encodeURI(category.name.toLowerCase())+"/"+category.id;
}
  seeCategory(category) {
    let name = category.name.replace(/\/|\s/g, "-").toLowerCase();
    this.navCtrl.navigateRoot("categories/"+encodeURI(name.toLowerCase())+"/"+category.id);
  }

  sort(){
    this.descending = !this.descending;
    this.order = this.descending ? 1 : -1;
  }

  goToHome(){
    this.navCtrl.navigateRoot("/accueil");
    
  }

  async seeAccount(ev) {
    const popover = await this.popoverController.create({
      component: AccountPopoverComponent,
      cssClass: 'my-custom-class',
      event: ev,
      translucent: true
    });
    return await popover.present();
  }

  async login(ev) {
    await this.displayer.presentModal( LoginPage );
    /*const popover = await this.popoverController.create({
      component: AccountPopoverComponent,
      cssClass: 'my-custom-class',
      event: ev,
      translucent: true
    });
    return await popover.present();*/
  }

  async search() {
    //this.displayer.presentModal(SearchModalComponent);
    /*const popover = await this.popoverController.create({
      component: SearchModalComponent,
      translucent: true
    });
    return await popover.present();*/
  }

  back() {
    this._location.back();
  }

}
